import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { blue, navy, glass, transition, getGlassStyle } from './colorUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Card', 'blueTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      borderRadius: 4,
      overflow: 'hidden',
      position: 'relative' as const,
      ...getGlassStyle(),
      border: `1px solid ${navy[700]}`,

      // 顶部荧光装饰线
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: 1,
        background: `linear-gradient(90deg, transparent, ${blue[500]}60, transparent)`,
        pointerEvents: 'none',
      },

      '&:hover': {
        borderColor: `${blue[500]}40`,
      },

      // 卡片头部
      [`${componentCls}-head`]: {
        borderBottom: `1px solid ${navy[700]}80`,
        background: `${glass.header}`,

        [`${componentCls}-head-title`]: {
          color: `#fff !important`,
          fontWeight: 600,
        },
      },

      [`${componentCls}-body`]: {
        background: 'transparent',
      },
    },
  }
})
